import { TIMEZONES } from '@common/utils/timezone-data'
import {
  VCalComponent,
  VObjectProperty
} from '@common/features/Calendars/types/CalendarData'
import { CalendarEvent } from '@common/types/EventsTypes'
import { makeTimezone } from '@common/features/Events/utils'
import { VcalendarProperties } from '@common/features/Calendars/types/VcalendarProperties'

export function updateSeriesPartstatJCal(
  vevents: VCalComponent[],
  event: CalendarEvent,
  attendeeEmail: string,
  partstat: string
): VCalComponent {
  // Update PARTSTAT in ALL VEVENTs (master + exceptions)
  const updatedVevents = vevents.map((vevent: VCalComponent) => {
    const properties = vevent[1] as VObjectProperty[]
    const updatedProperties = properties.map(
      (prop: VObjectProperty): VObjectProperty => {
        const calAddress = prop[3] as string
        // Find ATTENDEE properties & Check if this is the target attendee
        if (
          prop[0] === 'attendee' &&
          normalizeEmail(calAddress) === normalizeEmail(attendeeEmail)
        ) {
          // Update PARTSTAT parameter
          const params = { ...(prop[1] as Record<string, string>), partstat }
          return [prop[0], params, prop[2], prop[3]] as VObjectProperty
        }
        return prop
      }
    )
    return [vevent[0], updatedProperties, vevent[2]] as VCalComponent
  })

  const timezoneData = TIMEZONES.zones[event.timezone]
  const vtimezone = makeTimezone(timezoneData, event)

  return [
    'vcalendar',
    VcalendarProperties,
    [...updatedVevents, vtimezone.component.jCal]
  ]
}

const normalizeEmail = (addr: string): string =>
  addr
    .toLowerCase()
    .replace(/^mailto:/, '')
    .trim()
